var play_path_big = "//whhxparty.ehijoy.com/img/whhx_party/pic_find_holes/guide/game/bigimg/"
var play_path_small = "//whhxparty.ehijoy.com/img/whhx_party/pic_find_holes/guide/game/smallimg/"
var play_list = [
    {
        playid: 0,
        open: 0,
        pass: 0,
        has_title: 1,
        img: "",
        big_img: "",
        name: `卷零·春日宴饮`,
        time: '7月25日'
    },
    {
        playid: 1,
        open: 0,
        pass: 0,
        has_title: 0,
        img: "",
        big_img: "",
        name: `卷壹·动荡不宁`,
        time: '7月19日'
    }, {
        playid: 2,
        open: 0,
        pass: 0,
        has_title: 0,
        img: "",
        big_img: "",
        name: `卷贰·圣人巡狩`,
        time: '7月20日'
    }, {
        playid: 3,
        open: 0,
        pass: 0,
        has_title: 0,
        img: "",
        big_img: "",
        name: `卷叁·纵马击球`,
        time: '7月21日'
    }, {
        playid: 4,
        open: 0,
        pass: 0,
        has_title: 0,
        img: "",
        big_img: "",
        name: `卷肆·柄执朝权`,
        time: '7月22日'
    }, {
        playid: 5,
        open: 0,
        pass: 0,
        has_title: 0,
        img: "",
        big_img: "",
        name: `卷伍·长安风华`,
        time: '7月23日'
    }]


var hole_name = {
    '1': '疑点·壹',
    '2': '疑点·贰',
    '3': '疑点·叁',
    '4': '疑点·肆',
    '5': '疑点·伍',
    '6': '疑点·陆',
    '7': '疑点·柒',
    '8': '疑点·捌',
}


var holes_img_path = "//whhxparty.ehijoy.com/img/whhx_party/pic_find_holes/guide/game/holes/"
var play_holes = [  //疑点描述 index对应的是具体playid
    [
        { top: 1253, left: 1505, pass: 0, click_on: 0, holeid: 1, img: '', audio: "", def_name: '', name: '可乐', say: '一股药味，还冒泡泡，感觉不太像是能喝的' },
        { top: 1301, left: 950, pass: 0, click_on: 0, holeid: 2, img: '', audio: "", def_name: '', name: '方便面', say: '冲入热水就能享受美味了！' },
        { top: 744, left: 593, pass: 0, click_on: 0, holeid: 3, img: '', audio: "", def_name: '', name: '耳机', say: '王上，请播放“归心圣德”' },
        { top: 647, left: 810, pass: 0, click_on: 0, holeid: 4, img: '', audio: "", def_name: '', name: '自行车', say: '嗯，两个轮子真的能站得稳吗？' },
        { top: 683, left: 2184, pass: 0, click_on: 0, holeid: 5, img: '', audio: "", def_name: '', name: '奶茶', say: '呃，这个超好喝的！嚼嚼嚼~' },
        { top: 536, left: 1854, pass: 0, click_on: 0, holeid: 6, img: '', audio: "", def_name: '', name: '起重机', say: '真是伟大的发明啊' },
        { top: 592, left: 2895, pass: 0, click_on: 0, holeid: 7, img: '', audio: "", def_name: '', name: '小黄鸭', say: '神秘的动物，还挺可爱的呢' },
        { top: 929, left: 2880, pass: 0, click_on: 0, holeid: 8, img: '', audio: "", def_name: '', name: '游戏机', say: '王上，这就是你整天都在玩的东西吗' },
    ],
    [
        { top: 596, left: 827, pass: 0, click_on: 0, holeid: 1, img: '', audio: '', def_name: '', name: '电线杆', say: '王上，杆子上挂着线是做什么呀？' },
        { top: 696, left: 98, pass: 0, click_on: 0, holeid: 2, img: '', audio: '', def_name: '', name: '工作证', say: '这不就是腰牌嘛' },
        { top: 1216, left: 827, pass: 0, click_on: 0, holeid: 3, img: '', audio: '', def_name: '', name: '小熊玩偶', say: '嘻嘻，我喜欢这个！' },
        { top: 1084, left: 2366, pass: 0, click_on: 0, holeid: 4, img: '', audio: '', def_name: '', name: '棒棒糖', say: '哇，好甜' },
        { top: 793, left: 2949, pass: 0, click_on: 0, holeid: 5, img: '', audio: '', def_name: '', name: '手表', say: '没想到小小的一个机器里面有那么零件呢' },
        { top: 8, left: 2949, pass: 0, click_on: 0, holeid: 6, img: '', audio: '', def_name: '', name: '摄像头', say: '用这个就能抓到犯人了吧' },
        { top: 132, left: 2357, pass: 0, click_on: 0, holeid: 7, img: '', audio: '', def_name: '', name: '卡通发夹', say: '可爱的发夹~' },
        { top: 554, left: 1926, pass: 0, click_on: 0, holeid: 8, img: '', audio: '', def_name: '', name: '扩音器', say: '喂喂喂，能听到吗？' },
    ],
    [
        { top: 1198, left: 1696, pass: 0, click_on: 0, holeid: 1, img: '', audio: '', def_name: '', name: '空调外机', say: '车子上面也能装外机呀' },
        { top: 980, left: 2896, pass: 0, click_on: 0, holeid: 2, img: '', audio: '', def_name: '', name: '草坪告示牌', say: '要爱护花草哦' },
        { top: 1177, left: 2027, pass: 0, click_on: 0, holeid: 3, img: '', audio: '', def_name: '', name: '登山背包', say: '你还真别说，是挺搭的' },
        { top: 1302, left: 1482, pass: 0, click_on: 0, holeid: 4, img: '', audio: '', def_name: '', name: '狗粮盆', say: '为小狗准备饭盆' },
        { top: 1237, left: 1163, pass: 0, click_on: 0, holeid: 5, img: '', audio: '', def_name: '', name: '矿泉水瓶', say: '正好口渴了' },
        { top: 1064, left: 1254, pass: 0, click_on: 0, holeid: 6, img: '', audio: '', def_name: '', name: '简易时钟', say: '滴答滴答！' },
        { top: 1232, left: 71, pass: 0, click_on: 0, holeid: 7, img: '', audio: '', def_name: '', name: '摄像机', say: '得把这次出巡的精彩时刻记录下来' },
        { top: 100, left: 850, pass: 0, click_on: 0, holeid: 8, img: '', audio: '', def_name: '', name: '无人机', say: '航拍出的照片超赞的' },
    ],
    [
        { top: 527, left: 3068, pass: 0, click_on: 0, holeid: 1, img: '', audio: '', def_name: '', name: '路灯', say: '没想到这里还藏着个路灯' },
        { top: 1242, left: 1478, pass: 0, click_on: 0, holeid: 2, img: '', audio: '', def_name: '', name: '排球', say: '喂喂，是不是搞错了' },
        { top: 784, left: 535, pass: 0, click_on: 0, holeid: 3, img: '', audio: '', def_name: '', name: '自拍杆', say: '拍下最好的运动照！' },
        { top: 214, left: 330, pass: 0, click_on: 0, holeid: 4, img: '', audio: '', def_name: '', name: '飞机', say: '我也想乘坐飞机看看天上的风景呢' },
        { top: 651, left: 1193, pass: 0, click_on: 0, holeid: 5, img: '', audio: '', def_name: '', name: '装饰气球', say: '大唐的时候是没有气球的啦' },
        { top: 1221, left: 500, pass: 0, click_on: 0, holeid: 6, img: '', audio: '', def_name: '', name: '儿童自行车', say: '好可爱，我也可以骑着玩吗？' },
        { top: 613, left: 2872, pass: 0, click_on: 0, holeid: 7, img: '', audio: '', def_name: '', name: '牛仔帽', say: 'Howdy homie!' },
        { top: 937, left: 2900, pass: 0, high: 1, click_on: 0, holeid: 8, img: '', audio: '', def_name: '', name: '交通锥', say: '我绕左绕右绕中间', },
    ],
    [
        { top: 197, left: 1585, pass: 0, click_on: 0, holeid: 1, img: '', audio: '', def_name: '', name: '精致时钟', say: '好漂亮的时钟' },
        { top: 10, left: 1946, pass: 0, click_on: 0, holeid: 2, img: '', audio: '', def_name: '', name: '紧急出口', say: '遇到紧急事态往这边走' },
        { top: 1297, left: 2728, pass: 0, click_on: 0, holeid: 3, img: '', audio: '', def_name: '', name: '扫地机器人', say: '好神奇的小圆盘，地板一下子就干净了' },
        { top: 1132, left: 2563, pass: 0, click_on: 0, holeid: 4, img: '', audio: '', def_name: '', name: '魔法杖', say: '嗯？他手里拿着的是啥？' },
        { top: 984, left: 2219, pass: 0, click_on: 0, holeid: 5, img: '', audio: '', def_name: '', name: '电灯开关', say: '方便的开灯工具' },
        { top: 1115, left: 3068, pass: 0, click_on: 0, holeid: 6, img: '', audio: '', def_name: '', name: '纸杯', say: '纸居然可以做成杯子，不会漏水吗？' },
        { top: 1006, left: 284, pass: 0, click_on: 0, holeid: 7, img: '', audio: '', def_name: '', name: '钢笔', say: '比毛笔方便很多' },
        { top: 800, left: 842, pass: 0, click_on: 0, holeid: 8, img: '', audio: '', def_name: '', name: '智能手环', say: '居然能显示心跳欸！' },
    ],
    [
        { top: 517, left: 1600, pass: 0, click_on: 0, holeid: 1, img: '', audio: '', def_name: '', name: '开发区字牌', say: '很气派的牌子' },
        { top: 515, left: 1305, pass: 0, click_on: 0, holeid: 2, img: '', audio: '', def_name: '', name: '摩天大楼', say: '长安寸土寸金，房子确实要建高一些' },
        { top: 886, left: 797, pass: 0, click_on: 0, holeid: 3, img: '', audio: '', def_name: '', name: '外卖骑手', say: '感觉很辛苦的样子，要注意安全哟' },
        { top: 903, left: 319, pass: 0, click_on: 0, holeid: 4, img: '', audio: '', def_name: '', name: '空调外机', say: '又是外机，太简单啦' },
        { top: 1082, left: 1202, fat: 1, pass: 0, click_on: 0, holeid: 5, img: '', audio: '', def_name: '', name: '景区文化牌', say: '这种牌子写什么都感觉有点土欸' },
        { top: 1030, left: 2232, pass: 0, click_on: 0, holeid: 6, img: '', audio: '', def_name: '', name: '干粉灭火器', say: '要提高消防意识呀' },
        { top: 642, left: 2917, pass: 0, click_on: 0, holeid: 7, img: '', audio: '', def_name: '', name: '禁止攀爬标牌', say: '注意安全！' },
        { top: 566, left: 2400, pass: 0, click_on: 0, holeid: 8, img: '', audio: '', def_name: '', name: '手机', say: '这就是传说中的“手机”呀？' },
    ],
]


var get_play_list = function (my) { //根据本人的通关记录，获取play_list 已服务端为主
    // my = [{ open: 1, pass: 0 }...]
    my = my || []
    var arr = []
    play_list.forEach((item, index) => {
        item.img = `${play_path_small}${index + 1}.jpg`
        item.big_img = `${play_path_big}${index + 1}.jpg`

        var t = Object.assign({}, item, my[index])
        arr.push(t)
    })
    return arr
}
var get_play_holes = function (playid) {  //返回某个关卡的疑点
    var arr = play_holes[playid] || []

    var _arr = arr.map(i => {
        var t = Object.assign({}, i)

        t.def_name = hole_name[t.holeid];
        t.img = `${holes_img_path}${playid + 1}-${t.holeid}.jpg`
        return t
    })

    return _arr
}

function getQueryVariable(p_type) {
    var query = window.location.search.substring(1);
    var vars = query.split("&");

    var obj = {}
    for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split("=");
        obj[pair[0]] = pair[1]
    }
    obj.p_type = p_type || 1//页面1guide 2guest
    return obj
}

function copy_txt(val) {
    console.log(val)
    var input = document.createElement('input')
    input.value = val
    document.body.appendChild(input)
    input.select()
    document.execCommand('Copy') //执行copy操作
    document.body.removeChild(input)
}


var gfb_chn = function (chn) {
    return ['2', '3'].indexOf(chn) > -1
}

var isiOS = !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
var get_download_url = function (chn) {
    if (gfb_chn(chn)) {
        var url = isiOS ? 'https://apps.apple.com/cn/app/id1533570147' :
            'https://download01-official-whhx.ehijoy.com/2025.01.16/whhx_official202501.apk'

        return url
    }
    return ''
}
var is_h5 = !!(navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i))
//  跳转微信短链，去绑定的操作
var wx_url = 'https://neon.ehijoy.com/whhx/1'

var get_rest_time_txt = function (rest_time) {
    if (rest_time <= 0) { return '已结束' }

    var sec = rest_time
    var day = parseInt(sec / 86400)
    sec = sec % 86400
    var hour = parseInt(sec / 3600)
    var txt = (day ? `${day}天` : '') + (hour ? `${hour}小时` : '小于1小时')
    return txt
}



export default { get_play_list, get_play_holes, getQueryVariable, copy_txt, gfb_chn, get_download_url, get_rest_time_txt, wx_url, is_h5 }